var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_451_1263",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_451_1263",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACYElEQVR4nO3cPW4TYRjE8T+BBopcAAyiDydIKKAkXABzAUJFaDANEk2o+TDQE1oozAlMA3ThBEkHDYmCQCIuHrTSIlHwEYc33pmX5yeNFLnyjqVda8dZSCmllFJKqTNngdU2Z/JzOBzngc9AtGn+Xsyyy3v3U8k/8iaLLu/bL4puXkuFxW+S2nPoW2DvD0V1nb32FGR7vm++FewKFBn7zK7rN5mbAuXFlLmBqBPAENgRKCkOKdvAI+B4l0U/FSgiZpTmWDsxB3wVKCBmlC/tMWfRVFr0/3bqeEKHmgvEw/aCEZXmE/Cg64thSimllNLs1Xi/YwdB7wWKicLZQNArgWKicEYIeixQTBROcwtYzm2BYqJwBgi6KlBMFE4f0R+4RGVZQtBpgWKicHoIOgpMBMqJQmmO5RiitgQKikLZRNhrgYKiUMYIey5QUBTKOsLuCRQUhbKGsOsCBUWhrCDsskBBUSjLCDsnUFAUygLC5gUKikJpjkVaDQPANgZqGAA2MFDDADDCQA0DwBADNQwAAwzUMAD0MbAkUFT8Yyz+Q6uGAaCHAfcBYKJ8w7+mAWATI84DwBgjzgPAOkacB4A1jKwIFBYHzDWMLAsUFgfMJYw4DwALGHEeAOYx4zgAbGPIcQDYwJDjADDCkOMAMMTQQKC4mDK3MNQXKC6mzBUMOQ4AixhyHAB6GHIbACZON/ydB4BNjDkNAGOMPRMoMPaZ5r3acnps5irGTok/aTfaNO/xJObuChT5t9yhAnPts/FCNPeBI1TkIvAS+ChQ7gfgBXCh61JSSimllFJKKaWUMPQdPaFziuEZeyUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.7df935af80b807706ab273c5b6d584b4.svg";
export { ForwardRef as ReactComponent };